<template>
    <div v-click-outside="handleOutsideClick" class="cascade-select-wrapper">
        <label v-if="label" class="form-group-label d-block mb-1">
            {{ label }}
        </label>

        <button type="button" @click="modalOpen = !modalOpen" class="cascade-select">
            {{  selectedValue.length ? `${selectedValue.length} ${$t('general.selected')}` : placeholder }}
            <span class="cascade-select-arrow"></span>
        </button>
        <div v-show="modalOpen" class="cascade-select-dropdown">
            <nav class="cascade-select-dropdown-options">
                <button
                    @click="activeOption = option.name"
                    type="button"
                    v-for="option in options"
                    :key="option.name"
                    :class="[
                        'cascade-select-dropdown-options-button',
                        { active: activeOption === option.name },
                        { selected: hasSelectedValue(option) }
                    ]"
                >
                    {{ option.name }}

                    <ui-icon v-if="option.modules.length" icon="arrow-right" />

                    <div
                        v-if="option.modules.length"
                        v-show="activeOption === option.name"
                        class="cascade-select-dropdown-selects"
                    >
                        <ul class="list">
                            <li
                                v-for="select in option.modules"
                                :key="`module_dropdown${select.value}`"
                                class="cascade-select-input"
                            >
                                <label :for="select.value">

                                    <input
                                        v-model="selectedValue"
                                        type="checkbox"
                                        :value="select.value"
                                        name="module"
                                        :id="select.value"
                                    >

                                    {{ select.name }}
                                </label>
                            </li>
                        </ul>
                        <button type="button" class="btn btn-primary btn-sm cascade-select-save-button" @click="$emit('input', { ...selectedValue })">
                            <span>
                                {{ $t('general.save') }}
                            </span>
                        </button>
                    </div>
                </button>
            </nav>
        </div>

    </div>
</template>

<script>
import UiIcon from '@/components/ui/icon.vue';

export default {
    name: 'UicascadeSelect',
    components: {
        UiIcon,
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: null,
        },
        options: {
            type: Array,
            default: () => [],
        },
        selectedLoad: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            selectedValue: [],
            modalOpen: false,
            activeOption: '',
        };
    },
    methods: {
        handleOutsideClick() {
            this.modalOpen = false;
        },

        hasSelectedValue(option) {
            return this.selectedValue.some(select => option.modules.map(select => select.value).includes(select))
        },
    },
    watch: {
        selectedLoad: {
            immediate: true,
            handler(value) {
                const formattedArray = Object.keys(value).map((key) => value[key]);
                this.selectedValue = formattedArray;
            },
        },
    },
};
</script>

<style lang="scss">
    .cascade-select {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        min-height: inherit;
        padding: 0.75rem 1rem;
        margin: 0;
        font-size: 16px;
        background: #fff;
        border: 1px solid $gray;
        border-radius: 5px;

        &-arrow {
            position: absolute;
            top: 1px;
            right: 1px;
            width: 40px;
            height: 38px;
            padding: 4px 8px;
            text-align: center;
            transition: transform 0.2s ease;

            &::before {
                position: relative;
                top: 65%;
                right: 0;
                margin-top: 4px;
                color: $dark;
                content: '';
                border-color: $dark transparent transparent;
                border-style: solid;
                border-width: 5px 5px 0;
            }
        }

        &-input {
            padding: 6px 0;
            font-weight: 400;
            color: $dark;
        }

        &-save-button {
            width: 100%;
            margin: 8px 0 0 ;
        }

        &-wrapper {
            position: relative;
        }

        &-dropdown {
            position: absolute;
            right: 0;
            left: 0;
            z-index: 100;

            &-options {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: 100%;
                min-width: 250px;
                margin-top: -1px;
                background: #fff;
                border: 1px solid $gray;
                border-radius: 0 0 5px 5px;

                &-button {
                    position: relative;
                    display: flex;
                    width: 100%;
                    padding: 12px;
                    text-align: left;
                    white-space: nowrap;

                    .icon {
                        margin-left: auto;
                    }

                    &:hover {
                        background: $gray;
                    }

                    &.selected {
                        font-weight: bold;
                        border-left: 4px solid $primary;
                    }

                    &.active {
                        color: #fff;
                        background: $primary;
                    }
                }
            }

            &-selects {
                position: absolute;
                top: 0;
                left: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                min-width: 250px;
                padding: 0.75rem 1rem;
                background: #fff;
                border: 1px solid $gray;
                border-radius: 5px;
            }
        }
    }
</style>
